import { render, staticRenderFns } from "./SocialKeyTakeawaysComponent.vue?vue&type=template&id=95dd1fd2"
import script from "./SocialKeyTakeawaysComponent.vue?vue&type=script&lang=js"
export * from "./SocialKeyTakeawaysComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports